<template>
  <v-container fluid class="whois-system-container pa-0">
    <div class="bg-overlay"></div>

    <v-row align="center" justify="center" class="content-wrapper ma-0">
      <v-col cols="12" md="10" lg="8">
        
        <div class="text-center mb-10 fade-in">
          <div class="icon-glow mb-4">
            <v-icon size="64" color="#00e5ff">mdi-web-clock</v-icon>
          </div>
          <h1 class="system-title">SISTEMA WHOIS .NI</h1>
          <p class="system-subtitle">
            >> ESCANEO DE DISPONIBILIDAD Y ESTADO DE DOMINIOS_
          </p>
        </div>

        <div class="search-interface elevation-12 fade-in delay-1">
          <v-form @submit.prevent="toggle">
            <v-row no-gutters align="center">
              
              <v-col cols="auto" class="prompt-col hidden-xs-only pl-4 pr-2">
                <span class="user-text">root@nic:~$</span>
                <span class="cmd-text ml-1">search</span>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="domainRequest"
                  v-on:keyup="isDomainValid"
                  placeholder="ingrese_dominio"
                  solo
                  flat
                  hide-details
                  background-color="transparent"
                  class="cyber-input"
                  height="60"
                  autofocus
                  color="#00e5ff"
                ></v-text-field>
              </v-col>

              <v-col cols="auto" class="px-2" style="min-width: 130px;">
                <v-select
                  v-model="zonaId"
                  :items="items"
                  item-value="idZona"
                  item-text="zona"
                  :rules="[(v) => !!v || 'Campo Obligatorio']"
                  solo
                  flat
                  hide-details
                  background-color="rgba(0, 229, 255, 0.05)"
                  class="cyber-select rounded"
                  dense
                  :menu-props="{ contentClass: 'cyber-menu' }"
                >
                  <template v-slot:prepend-inner>
                    <span class="zone-label">zone></span>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="auto">
                <v-btn
                  color="#00e5ff"
                  height="60"
                  tile
                  depressed
                  class="run-btn"
                  @click="toggle"
                  :disabled="domainErr"
                >
                  <span class="black--text font-weight-bold text-h6 px-2">>_ BUSCAR</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
        
        <div v-if="domainErr" class="error-console mt-2 text-center">
          [ERROR]: SINTAXIS DE DOMINIO INVÁLIDA
        </div>

        <div class="results-area mt-8 fade-in delay-2">
           <enviar-solicitud-aprobacion
             v-bind:mensaje="domainRequest"
             v-bind:response="response"
             @addToList="addToList"
           >
           </enviar-solicitud-aprobacion>
        </div>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// --- TU SCRIPT ORIGINAL (INTACTO) ---
import EnviarSolicitudAprobacion from "@/components/EnviarSolicitudAprobacion";
import Vue from "vue";

export default {
  name: "buscar-dominio-terminal",
  components: { EnviarSolicitudAprobacion },
  props: {
    mensaje: String,
    response: Number,
    action: String,
  },
  data: () => ({
    loading: false,
    items: [],
    domainRequest: "",
    zona: "",
    zonaId: 0,
    dominiosList: [],
    reg: /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9]))*$/,
    domainError: "DOMAIN SYNTAX INVALID",
    domainErr: false,
  }),
  mounted() {
    this.getZonas();
  },
  methods: {
    isDomainValid: function() {
      if (!this.reg.test(this.domainRequest)) {
        this.domainErr = true;
      } else {
        this.domainErr = false;
      }
    },
    toasterMessageResponse: function(msg) {
      Vue.$toast.open({
        message: `SYSTEM: ${msg}`,
        type: "error",
      });
    },
    domainExist: function(data) {
      let existe = false;
      let item = JSON.parse(localStorage.getItem("localdomain") || "[]");
      const index = item.findIndex((x) => x.dominio === data.dominio);
      if (index >= 0) {
        existe = true;
        return existe;
      }
      return existe;
    },
    addToList(value) {
      if (localStorage.getItem("localdomain")) {
        let item = JSON.parse(localStorage.getItem("localdomain") || "[]");

        let conver = JSON.parse(value);
        if (this.domainExist(conver)) {
          this.toasterMessageResponse(
            "DOMAIN ALREADY REGISTERED IN LOCAL CACHE"
          );
          return;
        }
        item.push({
          idZona: conver.idZona,
          idNivel: conver.idNivel,
          dominio: conver.dominio,
          precioReal: conver.precio,
          moneda: conver.simbolo,
          idDescuento: 0,
          montoDescuento: 0,
        });

        localStorage.setItem("localdomain", JSON.stringify(item));
      } else {
        let conver = JSON.parse(value);
        localStorage.setItem(
          "localdomain",
          JSON.stringify([
            {
              idZona: conver.idZona,
              idNivel: conver.idNivel,
              dominio: conver.dominio,
              precioReal: conver.precio,
              moneda: conver.simbolo,
              idDescuento: 0,
              montoDescuento: 0,
            },
          ])
        );
      }
      this.$emit("addToList", "");
    },
    toggle() {
      let mszonavacia = "ZONE SELECTION REQUIRED";
      if (this.domainRequest.length > 0) {
        if (this.action) {
          localStorage.setItem("tempDomain", this.domainRequest);
          localStorage.setItem('dominioInicio', this.domainRequest);
          let index = this.items.findIndex((x) => x.idZona === this.zonaId);
          if (index > -1) {
            localStorage.setItem("tempZone", this.items[index].zona);
            localStorage.setItem("tempZoneId", this.zonaId);
            window.location.href = "buscardominio";
          } else {
            this.toasterMessageResponse(mszonavacia);
          }
        } else {
          var index = this.items.findIndex((x) => x.idZona === this.zonaId);
          if (index > -1) {
            this.$store.commit("searchDomain", this.domainRequest);
            this.$store.commit("searchZone", this.items[index].zona);
            this.$store.commit("searchZoneId", this.items[index].idZona);
          } else {
            this.toasterMessageResponse(mszonavacia);
          }
        }
      } else {
        this.toasterMessageResponse("DOMAIN NAME REQUIRED");
      }
    },
    getZonas: async function() {
      await this.$http.get(this.$keys("ZONAS")).then((resp) => {
        if (resp.status == 200) {
          this.items = resp.data;
          // Seleccionar el primero por defecto
          if(this.items.length > 0) this.zonaId = this.items[0].idZona;
        }
      });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&family=Montserrat:wght@800&display=swap');

/* --- LAYOUT & FONDO --- */
.whois-system-container {
  min-height: 100vh;
  background-color: #050a10; /* Negro azulado profundo */
  position: relative;
  font-family: 'Fira Code', monospace;
  overflow-x: hidden;
}

.bg-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  /* Degradado sutil estilo "noche" */
  background: radial-gradient(circle at 50% 30%, #0d1b2a 0%, #050a10 70%);
  z-index: 0;
}

.content-wrapper {
  position: relative;
  z-index: 2;
  padding-top: 50px;
}

/* --- HEADER --- */
.system-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 3.5rem;
  color: #fff;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-shadow: 0 0 20px rgba(0, 229, 255, 0.4);
}

.system-subtitle {
  color: #00e5ff;
  font-size: 1rem;
  letter-spacing: 1.5px;
  opacity: 0.9;
  font-weight: 600;
}

.icon-glow {
  filter: drop-shadow(0 0 15px #00e5ff);
}

/* --- BARRA DE BÚSQUEDA --- */
.search-interface {
  background: rgba(10, 16, 26, 0.95);
  border: 1px solid #004d5a;
  border-radius: 4px;
  box-shadow: 0 0 25px rgba(0, 229, 255, 0.1);
  transition: all 0.3s ease;
}

.search-interface:hover {
  border-color: #00e5ff;
  box-shadow: 0 0 35px rgba(0, 229, 255, 0.2);
}

/* Prompt Visual */
.prompt-col {
  display: flex;
  align-items: center;
  border-right: 1px solid #1a2634;
  height: 60px;
}
.user-text { color: #00e5ff; font-weight: bold; }
.cmd-text { color: #fff; }

/* Inputs */
.cyber-input >>> input {
  color: #fff !important;
  font-family: 'Fira Code', monospace;
  font-size: 1.2rem;
}
.cyber-input >>> input::placeholder {
  color: #4a6572 !important;
  font-style: italic;
}

/* Selector Zona */
.zone-label {
  color: #00e5ff;
  font-size: 0.9rem;
  margin-right: 5px;
}
.cyber-select >>> .v-select__selection {
  color: #fff !important;
  font-weight: 600;
}
.cyber-select >>> .v-icon {
  color: #00e5ff !important;
}

/* Botón RUN */
.run-btn {
  border-left: 2px solid #00e5ff;
  transition: background 0.2s;
}
.run-btn:hover {
  background-color: #80ffff !important; /* Cian más claro al hover */
  box-shadow: 0 0 20px #00e5ff;
}

/* Mensaje Error */
.error-console {
  color: #ff3366;
  background: rgba(255, 51, 102, 0.1);
  display: inline-block;
  padding: 5px 15px;
  border-radius: 4px;
  font-weight: bold;
}

/* Animaciones */
.fade-in {
  animation: fadeIn 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(10px);
}
.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }

@keyframes fadeIn {
  to { opacity: 1; transform: translateY(0); }
}

/* Responsive */
@media (max-width: 600px) {
  .system-title { font-size: 2.2rem; }
  .system-subtitle { font-size: 0.8rem; }
}
</style>

<style>
.cyber-menu .v-list {
  background-color: #0a101a !important;
  border: 1px solid #00e5ff !important;
  font-family: 'Fira Code', monospace !important;
}
.cyber-menu .v-list-item {
  color: #ffffff !important; /* Cambiado a blanco puro */
}
.cyber-menu .v-list-item:hover {
  background-color: rgba(0, 229, 255, 0.25) !important; /* Un poco más de brillo al pasar el mouse */
}
.cyber-menu .v-list-item__title {
  font-weight: 600;
  color: #ffffff !important; /* Esto asegura que la letra sea blanca ignorando el default de Vuetify */
}
</style>